export default "__VITE_ASSET__BMS_SiXK__"